import { AmplitudeExperiments, AmplitudeVariants } from '@/utils/amplitude/experiments/AmplitudeExperiments';
import { useAmplitudeExperimentBase } from '@/utils/amplitude/experiments/utils/useAmplitudeExperimentBase';

/**
 * App download prompt A/B experiment (`laac-1674-app-download-prompt`, LAAC-1674 / LAAC-1711).
 *
 * @returns true when the user is assigned to the treatment variant
 */
export const useAppDownloadPromptExperiment = () =>
    useAmplitudeExperimentBase(AmplitudeExperiments.AppDownloadPrompt, AmplitudeVariants.AppDownloadPrompt.Treatment);
